var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-sidebar',{attrs:{"title":_vm.sidebar.title,"icon":_vm.sidebar.icon,"active":_vm.$store.state.sidebars.showSettings}},[(_vm.$store.state.auth.isLoggedIn)?_c('settings-list'):_vm._e(),_c('app-version-box')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }